import { AxiosError } from "axios";
import IApiErrorResults from "common/interfaces/IApiErrorResults";
import IReturnResults from "common/interfaces/IReturnResults";

export function getAxiosErrorReturnResults(error: unknown): IReturnResults {
    let errorMessage = "unknown error occured";
    if (
      error instanceof AxiosError &&
      error.response &&
      Array.isArray(error.response.data?.errors)
    ) {
      const results: IApiErrorResults = error.response.data;
      if (results.errors.length > 0) {
        errorMessage = results.errors[0];
      }
    }
    return { succeeded: false, errorMessage: errorMessage };
  }